import React, { useState, useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import SidebarRFQ from "../POpage/SidebarRFQ";
import unreadicon from "../assets/images/unreadicon.png";
import timeicon from "../assets/images/timeicon.png";

dayjs.extend(relativeTime);

const AlertMessageallpo = () => {
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [poMessages, setPOMessages] = useState([]);

  useEffect(() => {
    if (user?.id) {
      fetchMessagesPO();
    }
  }, []);

  const fetchMessagesPO = async () => {
    try {
      const response = await axios.get(
        `https://bimanager.nexteck.uk/api/messagespo/${user.id}`
      );
      setPOMessages(response.data.messages.slice(0, 5));
    } catch (err) {
      console.error("PO fetch error:", err);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.post(`https://bimanager.nexteck.uk/api/messages/status-update`, {
        id,
        client_id: user.id,
      });
      fetchMessagesPO(); // Refresh after update
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  
  return (
    <div className="row">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <h2 className="text-xl fw-bold mb-4">Notifications</h2>

        <div className="card p-4  mb-4">
          <h6 className="fw-bold mb-3"> PO Alerts</h6>
          {poMessages.length > 0 ? (
            poMessages.map((alert) => (
              <div
                key={alert.id}
                className="d-flex justify-content-between align-items-center bglight p-2 mb-3 rounded-3"
                style={{ cursor: "pointer" }}
                onClick={() => markAsRead(alert.id)}
              >
                {/* Message */}
                <div className="d-flex align-items-center">
                  <div className="fw-semibold mx-2">{alert.message}</div>
                </div>

                {/* Status & Time */}
                <div className="d-flex align-items-center gap-4">
                  <div className="text-center mx-4">
                    <img src={unreadicon} alt="Unread Icon" style={{ width: "20px", height: "20px" }} />
                    <div className="small text-muted">{alert.status === "0" ? "Unread" : "Read"}</div>
                  </div>
                  <div className="text-center mx-3">
                    <img src={timeicon} alt="Time Icon" style={{ width: "20px", height: "20px" }} />
                    <div className="small text-muted">{dayjs(alert.created_at).fromNow()}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-muted">No alerts available.</div>
          )}
        </div>

       
      </div>
    </div>
  );
};

export default AlertMessageallpo;
